module.exports = __webpack_public_path__ + "static/media/delivery_receipts_active_es.cd4c3e29.svg";